import React from "react";
import { withRouter } from "react-router";
import ChangePasswordForm from "./ChangePasswordForm";

const Register = () => (
  <div className="account account--not-photo">
    <div className="account__wrapper">
      <div className="account__card change-password-min-width">
        <div className="account__head">
          <h2 className="account__title">
            <span className="account__logo">
              <span className="account__logo-accent"/>
            </span>
          </h2>
        </div>
        <ChangePasswordForm />
      </div>
    </div>
  </div>
);

export default withRouter(Register);
